import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamics-crm',
  templateUrl: './dynamics-crm.component.html',
  styleUrls: ['./dynamics-crm.component.css']
})
export class DynamicsCrmComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/dynamics-crm/dynamics-crm.component.ts